let lightlightgrey = 'rgba(0,0,0,0.07)';
let lightergrey = 'rgba(0,0,0,0.2)';
let middlegrey = 'rgba(0,0,0,0.4)';
let darkergrey = '#33475B';

let skilldGreen = '#18BC9C';

let lighterwhite = '#bbb';
let lightwhite = '#eee';
let white = '#FFFFFF';
let black = '#000000';
let transparant = 'rgba(0,0,0,0.0)';

const filterResult = '#b4d788';
const filterResultLight = '#c8f097';
const filterResultDark = '#9ebd77';

const selected = '#d35b97';

export class ColorConfig {
    public static hidden = transparant;
    public static white = white;
    public static black = black;
    public static skilldGreen = skilldGreen;
    public static selected = selected;
    public static selectedTransparent = 'rgba(211, 91, 151,0.25)';
    public static filterResultLight = filterResultLight;
    public static filterResult = filterResult;
    public static filterResultDark = filterResultDark;
    public static filterResultDarkTransparent = 'rgba(158,189,119,0.25)';

    // ******** Organigram colors *************
    public static organigramTechyConsultant = '#fe8022';
    public static organigramNonTechyConsultant = '#fe8022';
    public static organigramNonTechyQualityAtSpeed = '#017598';
    public static organigramTechyQualityAtSpeed = '#017598';

    public static organigramConsultantSelected = selected;
    public static organigramConsultantSelectedBorder = selected;
    public static organigramConsultantNormal = lightlightgrey;
    public static organigramConsultantNormalBorder = transparant;
    public static organigramConsultantEnabled = filterResult;
    public static organigramConsultantEnabledBorder = transparant;
    public static organigramTeamText = darkergrey;
    public static organigramTeamTextSelected = selected;
    public static organigramTeamTextFilterResult = filterResult;
    public static organigramTeamCircleBorder = lightergrey;
    public static organigramTeamCircleSelected = selected;
    public static organigramTeamCircleFilterResult = filterResultLight;
    public static organigramTeamCircleBorderSelected = selected;
    public static organigramTeamCircleBorderFilterResult = filterResult;
    public static organigramEm = lightergrey;
    public static organigramEmSelected = middlegrey;
    public static organigramEmBorder = transparant;
    public static organigramEngagementLine = middlegrey;
    public static organigramEngagementLineLight = darkergrey;
    public static organigramEngagementLineEndpoint = transparant;
    public static organigramEmSelectedBorder = darkergrey;
    public static organigramEmDeselected = lightergrey;
    public static organigramConsultantNameBackground = darkergrey;
    public static organigramConsultantName = lightwhite;
    public static organigramConsultantNameBorder = transparant;

    public static organigramEmHilightFill = darkergrey;

    public static organigramEngagementLineStrokeWidth = 1;

    public static futureEmployeeShade = 0.35;

    // ******** Info colors *************
    public static infoColorText = lighterwhite;

    // ******** User detail colors ***********
    public static userCircleBorder = lightergrey;
    public static userCircleColor = transparant;
    public static userPrimaryText = darkergrey;
}
